const server_error = {
  namespaced: true,
  state: {
    data: null,
    show: false,
    points_data: null,
    energy_data: null,
  },
  mutations: {
    writeServerErrorData(state, params) {
      state.data = params.data;
      state.show = true;
    },
    closeErrorPopup(state) {
      state.data = null;
      state.show = false;
    },
  },
};
export default server_error;
